import { render, staticRenderFns } from "./studentQuestion.vue?vue&type=template&id=2402e96a&scoped=true"
import script from "./studentQuestion.vue?vue&type=script&lang=js"
export * from "./studentQuestion.vue?vue&type=script&lang=js"
import style0 from "./studentQuestion.vue?vue&type=style&index=0&id=2402e96a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2402e96a",
  null
  
)

export default component.exports